<template>
  <b-card :title="title">
    <!-- chart -->
    <chartjs-component-doughnut-chart
      :height="275"
      :data="chartData"
      :options="chartOptions"
      class="mb-3"
    />
    <!--/ chart -->

    <!-- items -->
    <div
      v-for="(item, index) in data"
      :key="item.title"
      :class="index < data.length-1 ? 'mb-1':''"
    >
      <div
        class="d-flex align-items-center justify-content-between"
      >
        <div :style="{ color: item.color }">
          <feather-icon
            :icon="item.icon"
            size="16"
            :class="item.color"
          />
          <span class="font-weight-bold ml-75 mr-25">
            {{ item.title }}
          </span>
        </div>
        <span>{{ item.value }} ({{ item.percent }}%)</span>
      </div>
    </div>
    <!--/ items -->
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import ChartjsComponentDoughnutChart from '@/views/charts-and-maps/charts/chartjs/charts-components/ChartjsComponentDoughnutChart.vue'
import chartjsData from '@/views/charts-and-maps/charts/chartjs/chartjsData'
import { $themeColors } from '@themeConfig'

export default {
  components: {
    ChartjsComponentDoughnutChart,
    BCard,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      chartjsData,
    }
  },
  computed: {
    chartData() {
      return {
        datasets: [
          {
            labels: this.data.map(item => item.title),
            data: this.data.map(item => (item.percent)),
            backgroundColor: this.data.map(item => item.color),
            borderWidth: 0,
            pointStyle: 'rectRounded',
          },
        ],
      }
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        responsiveAnimationDuration: 500,
        cutoutPercentage: 60,
        legend: { display: false },
        tooltips: {
          callbacks: {
            label(tooltipItem, data) {
              const label = data.datasets[0].labels[tooltipItem.index] || ''
              const value = data.datasets[0].data[tooltipItem.index]
              const output = ` ${label} : ${value} %`
              return output
            },
          },
          // Updated default tooltip UI
          shadowOffsetX: 1,
          shadowOffsetY: 1,
          shadowBlur: 8,
          shadowColor: 'rgba(0, 0, 0, 0.25)',
          backgroundColor: $themeColors.light,
          titleFontColor: $themeColors.dark,
          bodyFontColor: $themeColors.dark,
        },
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.card .card-title {
  font-size: 16px;
}
</style>
